import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input } from 'reactstrap';

const SIN_OPTIONS = [];

const CustomInput = ({
  type = 'text',
  value,
  onChange,
  options = SIN_OPTIONS,
  label,
  defaultValue = '',
  // eslint-disable-next-line no-unused-vars
  colSize = 6, // se saca de `props` para que no llegue al <Input>
  disabled,
  ...props
}) => {
  return (
    <FormGroup>
      <Label>{label}</Label>
      {type === 'select' ? (
        <Input
          type="select"
          value={value || defaultValue}
          onChange={onChange}
          disabled={disabled}
          {...props}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      ) : (
        <Input
          type={type}
          value={value || defaultValue}
          onChange={onChange}
          {...props}
          disabled={disabled}
        />
      )}
    </FormGroup>
  );
};

CustomInput.propTypes = {
  disabled: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colSize: PropTypes.number,
};

export default CustomInput;
